// extracted by mini-css-extract-plugin
module.exports = {"insufficientBalance":"InsufficientModal_style_insufficientBalance__1zz2E","walletStatus":"InsufficientModal_style_walletStatus__KLvZp"};